import { createOptions } from 'options';
import { paymentStates, invoiceTypes } from './types';

export const paymentStateOptions = createOptions(paymentStates);
export const invoiceTypeOptions = createOptions(invoiceTypes);
